import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseApi } from "@/utils/baseApi";
import { calendarListApi } from "@/api/services/attendance/calendar/Calendar";
export const shiftRosterListApi = baseApi.injectEndpoints({

    endpoints: (builder) => ({
        getShiftRoster: builder.query({
            query: ({ month, empId, sortDirection, page, size, search }) =>
                ({url: API_ENDPOINTS.SHIFT_ROSTER.GET_SHIFT_ROSTER(month, empId, sortDirection, page, size, search)}),
            providesTags: ["ShiftRoster"],
        }),

        getDayType: builder.query({
            query: ({ empId, month }) =>
                ({url: API_ENDPOINTS.SHIFT_ROSTER.GET_DAY_TYPE(empId, month)}),
            providesTags: ["DayType"],
        }),

        getDayTypeList: builder.query({
            query: () =>
                ({url: API_ENDPOINTS.SHIFT_ROSTER.GET_DAY_TYPE_LIST()}),
            providesTags: ["DayType"],
        }),

        upsertDayType: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SHIFT_ROSTER.UPSERT_DAY_TYPE(),
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["DayType", "ShiftRoster"],
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                    dispatch(calendarListApi.util.invalidateTags(["Calendar"]));
                } catch (error) {
                    // ignore; toast handled at call site
                }
            },
        }),

    }),
});

export const {
    useGetShiftRosterQuery,
    useGetDayTypeQuery,
    useGetDayTypeListQuery,
    useUpsertDayTypeMutation,
} = shiftRosterListApi;
